import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Share, ContentCopy, Check,
     Instagram, OpenInNew, Lock, Public, Schedule
} from '@mui/icons-material';
import { shareTextOf, formatTimeAgo } from '../utils/Universalfunctions';
import '../styles/adminCard.scss';

const AdminCard = ({ item }) => {
     const [copied, setCopied] = useState(false);

     const {
          id, uid, userName, userInitials,
          problem, title, category, type,
          visibility, likes, comments,
          interestedCount, bookmarkCount,
          createdAt, editedAt, isEdited,
          instagram, content,
     } = item;

     const copyUID = () => {
          navigator.clipboard.writeText(uid || '');
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
     };

     const isPublic = visibility === 'Public';
     const isProblem = type === 'Problem';

     return (
          <div className={`ac-card ${isProblem ? 'ac-problem' : 'ac-idea'}`}>

               {/* Top bar */}
               <div className="ac-topbar">
                    <span className={`ac-type-badge ${isProblem ? 'problem' : 'idea'}`}>{type}</span>
                    <span className={`ac-vis-badge ${isPublic ? 'public' : 'private'}`}>
                         {isPublic ? <Public /> : <Lock />} {visibility}
                    </span>
                    {isEdited && <span className="ac-edited-badge">Edited</span>}
                    <span className="ac-id-chip">#{id}</span>
               </div>

               {/* User block */}
               <div className="ac-user-block">
                    <div className="ac-avatar">
                         {userInitials || userName?.slice(0, 2)?.toUpperCase() || 'U'}
                    </div>
                    <div className="ac-user-info">
                         <strong>{userName || 'Unknown'}</strong>
                         <div className="ac-uid-row">
                              <code>{uid || 'N/A'}</code>
                              <button className="ac-copy-btn" onClick={copyUID} title="Copy UID">
                                   {copied ? <Check /> : <ContentCopy />}
                              </button>
                         </div>
                         {instagram && (
                              <a
                                   href={`https://instagram.com/${instagram}`}
                                   target="_blank"
                                   rel="noreferrer"
                                   className="ac-insta"
                              >
                                   <Instagram /> @{instagram}
                              </a>
                         )}
                    </div>
               </div>

               {/* Divider */}
               <div className="ac-divider" />

               {/* Content */}
               <div className="ac-content">
                    <span className="ac-category">{category}</span>
                    {title && <h4 className="ac-title">{title}</h4>}
                    <p className="ac-problem">{problem?.slice(0, 100)}{problem?.length > 200 ? '...' : ''}</p>
                    {content && (
                         <div className="ac-has-content">
                              <span>Has rich content</span>
                         </div>
                    )}
               </div>

               {/* Metrics */}
               <div className="ac-metrics">
                    <div className="ac-metric"><span>{likes || 0}</span><label>Likes</label></div>
                    <div className="ac-metric"><span>{comments || 0}</span><label>Comments</label></div>
                    <div className="ac-metric"><span>{interestedCount || 0}</span><label>Interested</label></div>
                    <div className="ac-metric"><span>{bookmarkCount || 0}</span><label>Saved</label></div>
               </div>

               {/* Divider */}
               <div className="ac-divider" />

               {/* Timestamps */}
               <div className="ac-timestamps">
                    <div className="ac-time">
                         <Schedule />
                         <span>Submitted: <strong>{formatTimeAgo(createdAt)}</strong></span>
                    </div>
                    {editedAt && (
                         <div className="ac-time">
                              <Schedule />
                              <span>Edited: <strong>{formatTimeAgo(editedAt)}</strong></span>
                         </div>
                    )}
               </div>

               {/* Footer actions */}
               <div className="ac-footer">
                    <button onClick={() => shareTextOf(problem)} className="ac-action-btn">
                         <Share /> Share
                    </button>
                    <Link to={`/interested/${id}`} className="ac-action-btn primary" target="_blank">
                         <OpenInNew /> View Post
                    </Link>
               </div>

          </div>
     );
};

export default AdminCard;
